<script setup lang="ts">
import { ref } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';

import { useAuth } from '@/composable/msal';
import { Layouts } from '@/layouts/constants/Layout';
import NewLayout from '@/layouts/NewLayout.vue';
import OldLayout from '@/layouts/OldLayout.vue';

const router = useRouter();
const route = useRoute();

const auth = useAuth();

const isLoading = ref(false);
const displayName = ref<string>('');

router.beforeEach(() => {
  isLoading.value = true;
});

router.afterEach(() => {
  isLoading.value = false;
});

// To not wait for the DOM to be ready
// Instead fire the API as soon as possible
// To avoid render blocking
const init = async () => {
  const loggedIn = await auth.isUserSignedIn();
  if (!loggedIn) return;
  displayName.value = auth.getAccountInfo()?.name ?? 'Unknown';
};

init();
</script>

<template>
  <NewLayout v-if="route?.meta?.layout === Layouts.MODERN">
    <RouterView />
  </NewLayout>

  <OldLayout v-else :display-name="displayName" :is-loading="isLoading">
    <RouterView />
  </OldLayout>
</template>
